const extractAnswersFromPageResponse = (pageResponse) => {
  const answers = {};

  (pageResponse.answers || []).forEach((answer, index) => {
    const timestamp = answer.timestamp ? new Date(answer.timestamp) : new Date();
    answers[answer.appkey] = {
      ...answer,
      timestamp,
      index
    };
  });

  return answers;
};

export default extractAnswersFromPageResponse;
